var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsCardIconGrad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 43,
    viewBox: "0 0 82 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33334 41.5C4.50001 40.881 10.3191 37.0436 16.2619 26.6452C22.2048 16.2468 37.3095 25.4073 44.1191 31.2873C46.9048 34.6915 55.2619 34.8153 66.4048 8.07667C67.3333 5.60087 71.4191 0.834947 80.3333 1.57769",
    stroke: "#1C1C1C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsCardIconGrad);
export default __webpack_public_path__ + "static/media/stats-card-icon-grad.7fb5f3ccc709efd239a689d03c1dbe5c.svg";
export { ForwardRef as ReactComponent };